import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkTypeEnum } from '../../enums/link-type.enum';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  @Input()
  id: string;
  @Input()
  label: string;
  @Input()
  url: string;
  @Input()
  urlType: LinkTypeEnum;
  @Input()
  styleClass = '';
  @Input()
  isActive = true;

  public linkTypeEnum = LinkTypeEnum;
}
